import { ofetch } from 'ofetch';
import { fetchAuthSession } from 'aws-amplify/auth';

export default defineNuxtPlugin((_nuxtApp) => {
  const config = useRuntimeConfig();

  const api = ofetch.create({
    baseURL: config.public.apiUrl,
    async onRequest({ options }) {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        if (token) {
          const headers = new Headers(options.headers);
          headers.set('Authorization', `Bearer ${token}`);
          options.headers = headers;
        }
      } catch {
        // No session, do not attach token
      }
    },
  });

  return {
    provide: {
      api,
    },
  };
});
